import {HTTP_INTERCEPTORS, HttpClientModule} from '@angular/common/http';
import {NgModule} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {CurrentLanguageProvider, SessionDataProvider} from '@synisys/idm-session-data-provider-api-js';
import {
	CurrentLanguageManager,
	LoginGuard,
	MainOnlineProvidersModule,
	SessionDataProviderImpl
} from '@synisys/idm-ui-shell';
import {LoginPagePreventionGuard} from '@synisys/idm-ui-shell/app/services/login-page-prevention-guard';
import {AppComponent} from './app.component';
import {AppRouterModule} from './app.routing';
import {AsyncLocalStorageModule} from 'angular-async-local-storage';
import {ApiUserLoginGuard, CachingInterceptor} from '@synisys/ejustice-controls';
import {DynamicAppModule} from './module/dynamic.app.module';
import {MessageService} from '@synisys/idm-ng-controls';
import {HttpMessageService} from '@synisys/idm-message-language-service-client-js';
import {ActiveUsersTrackInterceptor} from '@synisys/ejustice-controls/src/app/interceptors/active-users-track-interceptor';
import {EXCLUDED_FOR_LOADING_URLS} from '@synisys/idm-ui-shell/app/services/loading.interceptor';
import {GoogleAnalyticsIntegrationService} from '@synisys/ejustice-controls/src/app/pages/administration/integrations/google/analytics/google-analytics-integration.service';
import {
	UIGlobalStateProvider
} from '@synisys/ejustice-controls/src/app/services/services/impl/ui-global-state-provider.service';
import {RegistrationAvailabilityGuard} from './service/registration-availability.guard';

@NgModule({
	imports: [
		BrowserModule,
		BrowserAnimationsModule,
		HttpClientModule,
		AppRouterModule,
		MainOnlineProvidersModule,
		AsyncLocalStorageModule,
		DynamicAppModule
	],
	declarations: [
		AppComponent
	],
	providers: [
		LoginPagePreventionGuard,
		LoginGuard,
		ApiUserLoginGuard,

		SessionDataProviderImpl,
		CurrentLanguageManager,

		GoogleAnalyticsIntegrationService,

		UIGlobalStateProvider,
		RegistrationAvailabilityGuard,

		{provide: CurrentLanguageProvider, useExisting: SessionDataProviderImpl},
		{provide: SessionDataProvider, useExisting: SessionDataProviderImpl},
		{provide: MessageService, useClass: HttpMessageService},

		{provide: HTTP_INTERCEPTORS, useClass: CachingInterceptor, multi: true},
		{provide: HTTP_INTERCEPTORS, useClass: ActiveUsersTrackInterceptor, multi: true},

		{provide: EXCLUDED_FOR_LOADING_URLS, useValue: 'metrics/collect', multi: true},
		{provide: EXCLUDED_FOR_LOADING_URLS, useValue: 'logs/collect', multi: true},
		{provide: EXCLUDED_FOR_LOADING_URLS, useValue: 'token/prolong', multi: true},
	],
	bootstrap: [AppComponent],
})
export class AppModule {
}
